import type { CSSProperties } from 'react';

const flowKeyframes = `
  @keyframes flowOuter {
    0% { stroke-dashoffset: 250; opacity: 0.6; stroke-width: 3.5; }
    40% { stroke-dashoffset: 0; opacity: 1; stroke-width: 4; }
    60% { stroke-dashoffset: 0; opacity: 1; stroke-width: 4; }
    100% { stroke-dashoffset: -250; opacity: 0.6; stroke-width: 3.5; }
  }
  @keyframes flowInner {
    0% { stroke-dashoffset: 200; opacity: 0.6; stroke-width: 3.5; }
    40% { stroke-dashoffset: 0; opacity: 1; stroke-width: 4; }
    60% { stroke-dashoffset: 0; opacity: 1; stroke-width: 4; }
    100% { stroke-dashoffset: -200; opacity: 0.6; stroke-width: 3.5; }
  }
`;

export type IconFlowProps = {
  animated?: boolean;
  height?: number | string;
  style?: CSSProperties;
  width?: number | string;
};

export const IconFlow = ({ animated = false, height = 23, style, width = 24 }: IconFlowProps) => (
  <>
    {animated ? <style>{flowKeyframes}</style> : null}
    <svg
      fill="none"
      height={height}
      style={{ filter: 'drop-shadow(0 2px 8px rgba(0, 0, 0, 0.08))', overflow: 'visible', ...style }}
      viewBox="0 0 84 44"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 41.2298C2 19.5649 19.9078 1.99999 42 2C64.0922 2 82 19.5649 82 41.2298"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
        style={
          animated
            ? {
                animation: 'flowOuter 4s ease-in-out infinite',
                strokeDasharray: 250,
                transformBox: 'fill-box',
                transformOrigin: 'center',
              }
            : undefined
        }
      />
      <path
        d="M66.2417 42.0012C66.1833 41.1982 66.0904 40.4056 65.9631 39.6237C63.9943 27.4717 54.0148 18.2256 42.0002 18.2256C29.2135 18.2256 18.7326 28.6974 17.7588 42.0012"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
        style={
          animated
            ? {
                animation: 'flowInner 4s ease-in-out infinite',
                strokeDasharray: 200,
                transformBox: 'fill-box',
                transformOrigin: 'center',
              }
            : undefined
        }
      />
    </svg>
  </>
);
